"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M19.744 19.744c-4.27 4.27-11.218 4.27-15.488 0a10.89 10.89 0 0 1-2.044-2.848h5.526c.896 0 1.708-.556 2.026-1.406A2.344 2.344 0 0 1 12 13.896a2.37 2.37 0 0 1 1.437.482 2.349 2.349 0 0 1 .807 1.132 2.16 2.16 0 0 0 2.019 1.386h5.524a10.89 10.89 0 0 1-2.043 2.848Zm-.046-10.375a.554.554 0 0 0-.777-.095l-5.122 4.01A3.49 3.49 0 0 0 12 12.79c-1.498 0-2.82.945-3.282 2.332a1.06 1.06 0 0 1-.98.667h-6a10.97 10.97 0 0 1-.658-3.234h2.632a.554.554 0 0 0 0-1.107H1.08a10.89 10.89 0 0 1 2.804-6.779L5.766 6.55a.556.556 0 0 0 .784 0 .554.554 0 0 0 0-.783L4.668 3.884a10.891 10.891 0 0 1 6.778-2.804v2.631a.555.555 0 0 0 1.107 0v-2.63a10.885 10.885 0 0 1 6.779 2.804L17.53 5.687a.554.554 0 1 0 .782.784l1.804-1.803a10.889 10.889 0 0 1 2.803 6.779h-2.63a.553.553 0 1 0 0 1.107h2.63a10.97 10.97 0 0 1-.657 3.234h-6c-.43 0-.832-.274-.973-.648a3.4 3.4 0 0 0-.63-1.122l4.944-3.871a.552.552 0 0 0 .095-.778Zm4.225 2.897A.541.541 0 0 0 24 12a.544.544 0 0 0-.077-.267 11.889 11.889 0 0 0-3.479-8.174v-.002l-.003-.002A11.89 11.89 0 0 0 12.267.078.536.536 0 0 0 12 0a.533.533 0 0 0-.266.078 11.887 11.887 0 0 0-8.178 3.479 11.887 11.887 0 0 0-3.479 8.178A.531.531 0 0 0 0 12c0 .098.032.186.077.265.03 1.378.294 2.748.797 4.049 0 .01-.006.019-.006.027 0 .166.074.308.187.41a11.87 11.87 0 0 0 2.501 3.693A11.9 11.9 0 0 0 12 23.935a11.9 11.9 0 0 0 8.443-3.491 11.863 11.863 0 0 0 2.5-3.692.545.545 0 0 0 .19-.41c0-.01-.007-.02-.007-.03.502-1.3.765-2.67.797-4.046Z",
    clipRule: "evenodd"
  })]
});